import React, { useState } from "react";
import "./styles/select.css";

const renderSelect = (placeholder,required, value, setValue, optionsArray, focused, setFocused) =>{
    const id = `input-${placeholder.replace(/\s+/g, "-").toLowerCase()}`;

    const shouldFloat = value !== "" || (required && focused);

    return(
        <div className="selectGroup">
            <select id={id} value={value} onChange={(e)=>{ setValue(e.target.value)}} onFocus={()=>setFocused(true)} onBlur={()=>setFocused(false)}>
                <option value="" disabled hidden>{placeholder}</option>
                {optionsArray.map((option, index)=>(
                    <option value={option.value}>{option.name}</option>
                ))}
            </select>
            <label htmlFor={id} className={`${required && value === ""? "warning" : ""} ${shouldFloat ? "float" : ""}`}>
                {required && value === "" ? `*Requerido: ${placeholder}` : placeholder}
            </label>    
        </div>    
    )
}

/**
 * @typedef {Object} SelectOption
 * @property {string} value - The value of the option.
 * @property {string} name - The display name of the option.
 */

/**
 * Renders a custom select input component.
 *
 * @param {string} placeholder - The placeholder text for the select.
 * @param {boolean} required - Indicates if the select is a required field.
 * @param {string} value - The current value of the select.
 * @param {function(string): void} setValue - The function to update the select's value.
 * @param {SelectOption[]} optionsArray - An array of options to display in the select.
 * @returns {JSX.Element} The rendered select component.
 */
const Select = ({placeholder, required, value, setValue, optionsArray}) =>{
    const [focused, setFocused] = useState(false);

    return(<>{renderSelect(placeholder, required, value, setValue, optionsArray, focused, setFocused)}</>)
}

export default Select;